import React from 'react';
import { Plus, Timer } from 'lucide-react';
import { Button } from '../ui/button';

function DashboardHeader({ user, onStartPomodoro, onQuickAdd }) {
  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <div className="min-w-0 flex-1">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white truncate">
              Welcome back, {user?.email?.split('@')[0]}
            </h1>
            <p className="text-gray-600 dark:text-gray-300 mt-1 text-sm sm:text-base">
              Let's organize your work and boost your productivity
            </p>
          </div>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 sm:ml-4">
            <Button 
              variant="outline" 
              onClick={onStartPomodoro}
              className="flex items-center justify-center space-x-2 w-full sm:w-auto"
              size="sm"
            >
              <Timer className="w-4 h-4" />
              <span className="hidden xs:inline">Start Pomodoro</span>
              <span className="xs:hidden">Pomodoro</span>
            </Button>
            <Button 
              onClick={onQuickAdd}
              className="flex items-center justify-center space-x-2 w-full sm:w-auto"
              size="sm"
            >
              <Plus className="w-4 h-4" />
              <span className="hidden xs:inline">Quick Add</span>
              <span className="xs:hidden">Add</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardHeader;
